export const FILTER = {
  RANK: 'rank',
  TYPE: 'type',
  DISPLAY: 'display',
  BOOKMARKED: 'bookmarked',
} as const;

export const DISPLAY = {
  GRID: 'grid',
  LIST: 'list',
} as const;

export type DisplayMode = (typeof DISPLAY)[keyof typeof DISPLAY];

export interface MyFoodsPageQueryParams {
  type: string;
  bookmarked: boolean;
  rank: number | number[];
  display: (typeof DISPLAY)[keyof typeof DISPLAY];
}
